import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select2OptionData } from "ng-select2";
import { CreateResult } from "../../models/create-result";
import { UserDataStoreService } from "../../services/user-data-store.service";
import { CardAcceptorConfigViewModel } from "../../models/card-acceptor-config-view-model";
import { CardAcceptorConfigService } from "../../services/card-acceptor-config.service";
import { PermissionEnum } from '../../services/guards/permissions';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from "ngx-toastr";
import { ConfirmationDialogComponent } from "../../partials/confirmation-dialog/confirmation-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-card-acceptor-config-view',
  templateUrl: './card-acceptor-config-view.component.html',
  styleUrls: ['./card-acceptor-config-view.component.scss']
})
export class CardAcceptorConfigViewComponent implements OnInit, OnDestroy {
  public cardAcceptorForm: FormGroup;
  public createResult: CreateResult;

  public disabled = false;
  public canEdit = false;
  public canAdd = false;
  public canDelete: boolean;
  public displayTAContent = false;
  public countries: Select2OptionData[];
  public regions: Select2OptionData[];
  public routingGroups: Select2OptionData[];
  public limitsClasses: Select2OptionData[];
  public supportTeams: Select2OptionData[];
  public languages: Select2OptionData[];
  public taMerchantStatuses: Select2OptionData[];
  public receiptGroups: Select2OptionData[];
  public currencies: Select2OptionData[];
  public cardAcceptorConfig: CardAcceptorConfigViewModel;
  private _destroyed$ = new Subject<any>();
  public creatingNew = false;
  public termApp = 1;
  public submitted = false;

  public DeleteButton: string;
  public AddButton: string;

  public warning: string;
  public raiseWarning: boolean;
  public raiseDanger: boolean;
  public danger: string;
  public terminalConfigType: string;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  public defaultCardAcceptorConfig: CardAcceptorConfigViewModel;

  public get terminalConfigTypes() {
    return [
      { id: 1, text: 'TermApp' },
      { id: 2, text: 'PostTerm' }
    ];
  }

  public get terminalConfigTypes1(): Select2OptionData[] {
    const items = [
      { id: "1", text: 'TermApp' },
      { id: "2", text: 'PostTerm' }
    ];
    this.ConfigTypesSelect2 = items;
    return items;
  }

  public ConfigTypesSelect2: Select2OptionData[] = [];

  constructor(private _route: ActivatedRoute,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _modalService: NgbModal) {
    this.initDefaultValues();
    this.cardAcceptorForm = this._formBuilder.group({
      id: [0],
      name: ['', [Validators.required]],
      participantId: [_userDataStore.selectedParticipant.id],
      terminalConfigType: ['', Validators.required],
      country: ['ZA', Validators.required],
      currencyCode: [710, Validators.required],
      cvsRetailerId: null,
      defaultLang: [0, Validators.required],
      limitsClass: [null], //Changed
      merchantActive: [1],
      merchantStatus: [1], //changed
      nui: [null],
      receiptGroupId: [''],
      region: ['', Validators.required], //Changed
      routingGroup: ['', Validators.required], //Changed
      status: [null],
      supportTeam: [null],
      transactionThreshold: [null],
      velocityPeriod: [null],
      velocityThreshold: [null],
      worstEventSeverity: [null]
    });


    this._route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      if (params.id != 'new') {
        //check if user is eligible to edit and delete
        this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddMerchantConfiguration], []);
        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchantConfiguration], []);

        if (!this.canEdit && !this.canAdd) {
          //this._toastService.warning("Please note that you do not have the required permissions to update a terminal config.", "Warning");
          this.AddButton = "display:none";
          this.warning = "Please note that you do not have the required permissions to update this merchant config";
          this.raiseWarning = false;//Frans: changed to false

          //disable controls.
          Object.keys(this.cardAcceptorForm.controls).forEach(key => {
            this.cardAcceptorForm.controls[key].disable();
          });

        }
        this.canDelete = this._userDataStore.hasRequiredPermissions([PermissionEnum.DeleteMerchantConfiguration], []);

        this.disabled = true;
        const result = await this._cardAcceptorConfigService.Get(params.id);
        if (result.receiptGroupId == null)
          result.receiptGroupId = 0
        this.cardAcceptorForm.patchValue(result);

        this.cardAcceptorConfig = await this._cardAcceptorConfigService.Get(params.id);
        this.creatingNew = false;
        this.updateForm();

      } else {
        this.creatingNew = true;
        this.cardAcceptorForm.patchValue(this.defaultCardAcceptorConfig);
        this.updateForm();
        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddMerchantConfiguration], []);
        if (!this.canAdd) {
          this.AddButton = "display:none";
        }
        //hide delete button
        this.DeleteButton = "display:none";
      }
    });
  }

  public initDefaultValues(): void {
    this.defaultCardAcceptorConfig = {
      country: 'ZA',
      currencyCode: 710,
      cvsRetailerId: '',
      defaultLang: 0,
      id: 0,
      limitsClass: 'DefaultLimitsClass',
      merchantActive: 1,
      merchantStatus: 1,
      name: `Merchant config - ${Math.floor(Date.now() / 1000)}`,
      nui: '',
      participantId: this._userDataStore.selectedParticipant.id,
      receiptGroupId: 0,
      region: 'GP',
      routingGroup: 'DefaultRoutingGroup',
      status: '',
      supportTeam: 0,
      terminalConfigType: 1,
      transactionThreshold: 200,
      velocityPeriod: 10,
      velocityThreshold: 5,
      worstEventSeverity: 1
    };
  }

  public async ngOnInit(): Promise<void> {
    this.countries = (await this._cardAcceptorConfigService.GetCountries()).map((x) => {
      return { id: x.countryCode, text: x.country }
    });

    this.currencies = (await this._cardAcceptorConfigService.GetCountries()).map((x) => {
      return { id: x.currencyCode.toString(), text: x.country + ' (' + x.currencyCode + ')' }
    });

    this.limitsClasses = (await this._cardAcceptorConfigService.GetLimitsClasses()).map((x) => {
      return { id: x.limitsClass, text: x.limitsClass }
    });

    this.routingGroups = (await this._cardAcceptorConfigService.GetRoutingGroups()).map((x) => {
      return { id: x.routingGroup, text: x.routingGroup }
    });

    this.regions = (await this._cardAcceptorConfigService.GetRegions()).map((x) => {
      return { id: x.regionCode, text: x.regionName }
    });

    this.supportTeams = (await this._cardAcceptorConfigService.GetSupportTeams()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.languages = (await this._cardAcceptorConfigService.GetLanguages()).map((x) => {
      return { id: x.language.toString(), text: x.description }
    });

    this.taMerchantStatuses = (await this._cardAcceptorConfigService.GetTAMerchantStatuses()).map((x) => {
      return { id: x.statusId.toString(), text: x.description }
    });

    const receiptGroupsType = await this._cardAcceptorConfigService.GetReceiptGroups();

    receiptGroupsType.push({ groupId: 0, description: 'Clear' });
    this.receiptGroups = (receiptGroupsType).map((x) => {
      return { id: x.groupId.toString(), text: x.description }
    });
  }

  public async updateForm(): Promise<void> {
    setTimeout(() => {

      var i = this.cardAcceptorForm.controls.terminalConfigType.value;
      //const termType = this.cardAcceptorConfig.terminalConfigType;
      //var i1 = this.cardAcceptorForm.controls.terminalConfigType.value;
      //const ii = this.terminalConfigTypes;
      if (i == 1) {//TermApp
        this.displayTAContent = true;
      }
      else {//PostTermAApp
        this.displayTAContent = false;
      }
    }, 2000);
    //this.displayTAContent = +this.cardAcceptorForm.controls.terminalConfigType.value === this.termApp;
  }

  public async save(): Promise<void> {
    const configViewModel: CardAcceptorConfigViewModel = this.cardAcceptorForm.value;
    if ((!this.canEdit && !this.creatingNew) || (this.creatingNew && !this.canAdd)) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this.submitted = true;
      if (this.cardAcceptorForm.valid) {

        configViewModel.terminalConfigType = +configViewModel.terminalConfigType;
        configViewModel.supportTeam = + configViewModel.supportTeam;
        configViewModel.defaultLang = Number(configViewModel.defaultLang);

        if (configViewModel.terminalConfigType == 1) {//TermApp
          if (configViewModel.receiptGroupId != undefined) {//configViewModel.receiptGroupId != 0 &&
            configViewModel.receiptGroupId = Number(configViewModel.receiptGroupId);
          }
          else {
            if (this.cardAcceptorConfig != null) {
              configViewModel.receiptGroupId = this.cardAcceptorConfig.receiptGroupId;
            } else {
              configViewModel.receiptGroupId = null;
            }
          }
        }
        else {
          configViewModel.receiptGroupId = null;
        }

        if (!this.creatingNew) {
          this.createResult = await this._cardAcceptorConfigService.Update(configViewModel);
        } else {
          this.createResult = await this._cardAcceptorConfigService.Add(configViewModel);
        }
        if (this.createResult.success === true) {
          await this._router.navigate(['management', 'card-acceptor-config']);
          this._toastService.success(this.createResult.message, "Success");
        } else {
          this._toastService.error(this.createResult.message, "Error");
          this.raiseDanger = true;
          this.danger = this.createResult.message;
        }
      }
    }
  }

  public async delete(): Promise<void> {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      const result = await this._cardAcceptorConfigService.DeleteCardAcceptorConfig(this.cardAcceptorForm.controls.id.value);
      if (result.success === true) {
        await this._router.navigate(['management', 'card-acceptor-config']);
        this._toastService.success(result.message, "Success");
      } else {
        this._toastService.error(result.message, "Error");
      }
    }
  }

  public async determineDeleteDialog() {
    const merchantDetails = await this._cardAcceptorConfigService.GetAllMerchantDetails(this.cardAcceptorForm.controls.id.value);
    if (!!merchantDetails && merchantDetails.length === 0) {
      await this.openDeleteConfirmationDialog();
    } else {
      await this.openUsedDeleteFailureConfirmationDialog(merchantDetails.map(md => 'MID: ' + md.merchantNumber));
    }
  }

  public async openDeleteConfirmationDialog() {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = "Yes";
    dialogRef.componentInstance.cancelButtonText = "No"
    dialogRef.componentInstance.title = "Merchant Config Removal"
    dialogRef.componentInstance.message = "Are you sure you want to delete the selected merchant config?"

    const result = await dialogRef.result;
    if (result) {
      await this.delete();
    }
  }

  public async openUsedDeleteFailureConfirmationDialog(merchants: string[]) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = "OK"
    dialogRef.componentInstance.title = "Merchant Config Cannot Be Removed"
    dialogRef.componentInstance.message = "This Merchant Config is currently in use and cannot be deleted.<br/><br/><b>Merchants using config:</b>"
    dialogRef.componentInstance.listMessage = merchants;
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
